import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';

const AttachmentNameDisplay = ({ attachments = [], maxLines = 2 }) => {
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const textRef = useRef(null);
  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        const isOverflowing = textRef.current.scrollHeight > textRef.current.clientHeight;
        setShowToggle(isOverflowing);
      }
    };

    checkOverflow();
  }, [attachments]);

  return (
    <Box>
      <Typography
        variant="body2"
        style={{
          marginTop: '8px',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: expanded ? 'none' : maxLines,
          WebkitBoxOrient: 'vertical',
          whiteSpace: expanded ? 'normal' : 'initial', // allow wrapping when expanded
        }}
        ref={textRef}
      >
        {attachments.map((att, idx) => (
          <>
            {att.name}
            {idx < attachments.length - 1 && <br />}
          </>
        ))}
      </Typography>

      {showToggle && (
        <Typography
          variant="body2"
          onClick={() => setExpanded(!expanded)}
          sx={{
            mt: 0.5,
            color: 'primary.main',
            cursor: 'pointer',
            display: 'inline-block',
          }}
        >
          {expanded ? 'Show less' : 'Show more...'}
        </Typography>
      )}
    </Box>
  );
};

export default AttachmentNameDisplay;
